<template>
  <div>
    <h1>Sign Up Fix (Activation)</h1>

    <KadoMenu />

    <table class="table-signupfix">
      <tr>
        <td>
          Username:
        </td>
        <td>
          <div class="div-signupfix-inputText">
            <input class="inputText-common" type="text" placeholder="Username" v-model="username" required />
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Verification Code:
        </td>
        <td>
          <div class="div-signupfix-inputText">
            <input class="inputText-common" type="text" placeholder="verification Code" v-model="verificationCode" required />
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div class="div-signupfix-button" >
            <button class="button-normal button-normal__extra" name="SignUpFix" @click="signUpFix" >Activate</button>
          </div>
        </td>
      </tr>
    </table>
    <div v-if="procMsgNormal" class="div-procMsg-normal">{{ procMsgNormal }}</div>
    <div v-if="procMsgAttention" class="div-procMsg-attention">{{ procMsgAttention }}</div>
  </div>
</template>

<script>
// 共通定数
import { MyConfig as mc } from '@/MyConfig'
// 認証モジュール
import { MyAuth } from '@/my-modules/my-auth'
// コンポーネント：角メニュー
import KadoMenu from '@/components/KadoMenu.vue'

export default {
  name: 'SignUpFix',

  components: {
    KadoMenu
  },

  data () {
    return {
      username: '',
      verificationCode: '',
      procMsgNormal: null,
      procMsgAttention: null
    }
  },

  methods: {

    /* =================================================================================
     * signUpFix
     *   サインアップを完了
     * ============================================================================== */
    signUpFix () {
      mc.LOG_LEVEL ? console.log('%c info: call=myAuth.signUpFix: Start', mc.LOG_TYPE_I) : (() => {})()
      this.resetProcMsg()
      if (this.username && this.verificationCode) {
        const myAuth = new MyAuth()
        myAuth.signUpFix(this.username, this.verificationCode)
          .then(result => {
            mc.LOG_LEVEL ? console.log('%c info: call=myAuth.signUpFix: OK', mc.LOG_TYPE_I) : (() => {})()
            this.WriteProcMsg('normal', 'All steps of sign up has been done, you can sign in.')
            setTimeout(() => { this.$router.push('/auth/signin') }, mc.MSG_TIMEOUT)
          })
          .catch(err => {
            mc.LOG_LEVEL ? console.log('%c error: call=myAuth.signUpFix: err:', mc.LOG_TYPE_E, err) : (() => {})()
            this.WriteProcMsg('attention', JSON.stringify(err))
          })
      }
    },

    /* =================================================================================
     * WriteProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    WriteProcMsg (type, content) {
      if (type === 'normal') {
        this.procMsgNormal = content
        setTimeout(() => { this.procMsgNormal = null }, mc.MSG_TIMEOUT)
      } else if (type === 'attention') {
        this.procMsgAttention = content
        setTimeout(() => { this.procMsgAttention = null }, mc.MSG_TIMEOUT)
      }
    },

    /* =================================================================================
     * resetProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    resetProcMsg () {
      this.procMsgNormal = null
      this.procMsgAttention = null
    }
  }
}
</script>

<style scoped>
.table-signupfix {
  margin-left: auto;
  margin-right: auto;
}
.div-signupfix-inputText {
  width: 10em;
  margin: 0 0.2em 0.2em 0.2em;
}
.div-signupfix-button {
  padding-top: 1em;
  text-align: center;
}
.button-normal__extra {
  width: 10em;
}
</style>
